// JoinCourseForm.jsx
import React, { useState } from "react";
import "./JoinCourseForm.css";

const JoinCourseForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    pincode: "",
    enquiry: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/form/join-course`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      }
    );

    const data = await res.json();

    if (data.success) {
      alert("Form submitted successfully!");
      setFormData({
        name: "",
        phone: "",
        pincode: "",
        enquiry: "",
        message: ""
      });
    } else {
      alert("Failed to send. Try again.");
    }
  } catch (error) {
    console.error(error);
    alert("Server error.");
  }
};



  return (
    <section className="jc-form-section">
      <h2 className="jc-form-title">
        I want to join the Course, Sign me up!
      </h2>

      <p className="jc-form-subheading">First Step to Become a Teacher!</p>

      <form className="jc-form-container" onSubmit={handleSubmit}>

        {/* 2-column fields */}
        <div className="jc-form-group">
          <label>Your Name (Required)</label>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="jc-form-group">
          <label>Phone (Required)</label>
          <input
            type="text"
            name="phone"
            placeholder="Enter your phone number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="jc-form-group">
          <label>Area PIN Code (Required)</label>
          <input
            type="text"
            name="pincode"
            placeholder="Your Area Pin Code"
            value={formData.pincode}
            onChange={handleChange}
            required
          />
        </div>

        <div className="jc-form-group">
          <label>Enquiring for (Required)</label>
          <select
            name="enquiry"
            value={formData.enquiry}
            onChange={handleChange}
            required
          >
            <option value="">Choose one</option>
            <option value="Admissions">Admissions</option>
            <option value="Hire Teacher">Hire Teacher</option>
            <option value="Franchise Partner">Franchise Partner</option>
            <option value="Branch info">Branch info</option>
            <option value="Others (mention reason)">Others (mention reason)</option>
          </select>
        </div>

        {/* Full width textarea */}
        <div className="jc-form-group full-width">
          <label>Should we know anything before we call you?</label>
          <textarea
            name="message"
            placeholder="Write here..."
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>

        {/* Full width Button */}
        <button type="submit" className="jc-submit-btn">
          Submit
        </button>

      </form>
    </section>
  );
};

export default JoinCourseForm;
